export interface Volume {
  number: number
  title: string
  classes: string
  description: string
  cover: string
}

export const volumes: Volume[] = [
  {
    number: 1,
    title: 'Foundations & Gentle Yoga™',
    classes: '20 Classes',
    description:
      'Accessible, foundational and gentle classes for teaching with clarity, structure and confidence.',
    cover: 'https://cdn.magicpatterns.com/patterns/generated-images/985d7f61-1e97-421c-8ce9-a37c72bf86be.jpg',
  },
  {
    number: 2,
    title: 'Hatha & Balanced Flow™',
    classes: '20 Classes',
    description:
      'Complete balanced practices combining structure, breath, movement and intentional sequencing.',
    cover: 'https://cdn.magicpatterns.com/patterns/generated-images/1f0d507b-fb43-4f11-8344-7b536a56a68d.jpg',
  },
  {
    number: 3,
    title: 'Slow Flow & Mindful Movement™',
    classes: '20 Classes',
    description:
      'Slower-paced sessions built around mindful movement, controlled transitions and intentional pacing.',
    cover: 'https://cdn.magicpatterns.com/patterns/generated-images/84bc356d-625c-4303-8fdc-76c058df3721.jpg',
  },
  {
    number: 4,
    title: 'Mobility & Functional Yoga™',
    classes: '20 Classes',
    description:
      'Practical mobility-focused sessions that expand your teaching options beyond traditional flows.',
    cover: 'https://cdn.magicpatterns.com/patterns/generated-images/dbdbaf31-4aca-4441-a6e4-04ce69ca971b.jpg',
  },
  {
    number: 5,
    title: 'Restorative, Yin & Deep Release™',
    classes: '20 Classes',
    description: 'Slower, restorative and deep-release practices for lower-intensity teaching.',
    cover: 'https://cdn.magicpatterns.com/patterns/generated-images/bcde2403-f1ee-4bf0-a4f2-6f5b7a7f2077.jpg',
  },
  {
    number: 6,
    title: 'Specialty Yoga Class Vault™',
    classes: '20 Classes',
    description:
      'Additional specialty classes for moments when a standard general yoga session isn’t what you need.',
    cover: 'https://cdn.magicpatterns.com/patterns/generated-images/b2875aea-dff3-4bfd-b328-0e88fd69de10.jpg',
  },
]
